import React from "react";
import { Routes, Route, BrowserRouter } from 'react-router-dom';

import LoginPage from '../pages/login';
import LoginTerceirosPage from '../pages/login-terceiros';
import LoginTerceirosCodePage from '../pages/login-terceiros-code';
import AlterarSenhaAcessoPage from '../pages/alterar-senha-acesso';

const Rotas = () => {

    return (
        <BrowserRouter>
            <Routes>
                <Route exact path='/' element={<LoginPage />}></Route>
                <Route exact path='/login' element={<LoginPage />}></Route>
                <Route exact path='/login-terceiros' element={<LoginTerceirosPage />}></Route>
                <Route exact path='/login-terceiros-code' element={<LoginTerceirosCodePage />}></Route>
                <Route exact path='/alterar-senha-acesso' element={<AlterarSenhaAcessoPage />}></Route>
            </Routes>
        </BrowserRouter>
    )
}

export default Rotas;